<template>
    <div class="sidebar">
        <div class="sidebar-backdrop" @click="closeSidebarPanel" v-if="isPanelOpen"></div>
        <transition name="slide">
            <div v-if="isPanelOpen"
                 class="sidebar-panel">
                <slot></slot>
            </div>
        </transition>
    </div>
</template>
<script>
    import { store, mutations } from '@/store.js'
    
    export default {
        name: "Sidebar",
        methods: {
            closeSidebarPanel: mutations.toggleNav
        },
        computed: {
            isPanelOpen() {
                return store.isNavOpen
            }
        }
    }
</script>
<style>
    .slide-enter-active,
    .slide-leave-active
    {
        transition: transform 0.2s ease;
    }

    .slide-enter,
    .slide-leave-to {
        transform: translateX(-100%);
        transition: all 150ms ease-in 0s
    }

    .sidebar-backdrop {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        cursor: pointer;
        z-index: 2;
    }

    .sidebar-panel {
        /* overflow-y: auto; */
        background-color: #016F70;
        position: fixed;
        left: 0;
        top: 0;
        height: 100vh;
        z-index: 998;
        padding: 20px 20px 2rem 20px;
        width: 300px;
    }
    
    @media screen and (min-width: 1024px) {
        .sidebar-panel {
             padding: 2vw 2vw;
        }
    }
    
    @media screen and (max-width: 768px) {
        .sidebar-panel {
            width: 100%;
        }
    }
</style>